import FlexContainer from '@pitchero/react-ui/dist/cjs/components/FlexContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { ScrollBox, withTheme } from '@pitchero/react-ui';
import { get } from 'lodash';
import SecondaryNavigationLinks from '../navigation/secondary-navigation-links';

const MatchCentreNavigation = ({
  activeSection,
  teamId,
  fixtureId,
  hasEvents,
  hasLineup,
  hasPhotos,
  hasReport,
  hasScorecard,
  hasTable,
  uiTheme,
}) => {
  const links = [
    {
      name: 'overview',
      route: 'team.match_centre.overview',
      params: { teamId, fixtureId },
      transKey: 'teams:match_centre_preview_link',
    },
    ...(hasReport
      ? [
          {
            name: 'report',
            route: 'team.match_centre.report',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_report_link',
          },
        ]
      : []),
    ...(hasEvents
      ? [
          {
            name: 'events',
            route: 'team.match_centre.events',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_events_link',
          },
        ]
      : []),
    ...(hasScorecard
      ? [
          {
            name: 'scorecard',
            route: 'team.match_centre.scorecard',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_scorecard_link',
          },
        ]
      : []),
    ...(hasLineup
      ? [
          {
            name: 'lineup',
            route: 'team.match_centre.lineup',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_lineup_link',
          },
        ]
      : []),
    ...(hasTable
      ? [
          {
            name: 'table',
            route: 'team.match_centre.table',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_table_link',
          },
        ]
      : []),
    ...(hasPhotos
      ? [
          {
            name: 'photos',
            route: 'team.match_centre.photos',
            params: { teamId, fixtureId },
            transKey: 'teams:match_centre_photos_link',
          },
        ]
      : []),
  ];

  return (
    <ScrollBox xOnly component="div">
      <FlexContainer
        justifyContent="center"
        style={{ paddingBottom: '20px', width: 'min-content', margin: '0 auto' }}
      >
        <SecondaryNavigationLinks
          links={links}
          color="#fff"
          underlineColor={get(uiTheme, 'colors.primary', '#fff')}
          activeSection={activeSection}
        />
      </FlexContainer>
    </ScrollBox>
  );
};

MatchCentreNavigation.propTypes = {
  activeSection: PropTypes.string.isRequired,
  fixtureId: PropTypes.string.isRequired,
  teamId: PropTypes.number.isRequired,
  hasEvents: PropTypes.bool.isRequired,
  hasLineup: PropTypes.bool.isRequired,
  hasReport: PropTypes.bool.isRequired,
  hasScorecard: PropTypes.bool.isRequired,
  hasPhotos: PropTypes.bool.isRequired,
  hasTable: PropTypes.bool.isRequired,
  uiTheme: PropTypes.shape({}).isRequired,
};

export default withTheme(MatchCentreNavigation);
